import React from 'react';

import { ArticleType } from '@/type/article';
import { currentLocaleUrl } from '@/utils';

import PC from './pc';
import M from './m';
import TransferCom from '../public/TransferCom';

function FaqPage({ list }: { list: ArticleType[] }) {
    /** 跳转文章详情页 */
    const toArticle = (page: string) => {
        window.open(currentLocaleUrl(`/article/${page}`));
    };

    const itemProps = {
        list,
        toArticle,
    };

    return <TransferCom pc={<PC {...itemProps} />} m={<M {...itemProps} />} />;
}

export default FaqPage;
